import { Button, Checkbox } from "@arco-design/web-react";
import { IconCopy, IconDelete, IconExport } from "@arco-design/web-react/icon";
import BatchCollection, { IBatchCollection } from "./BatchCollection";
import "./BatchAction.less";
import {ReactNode, useEffect} from "react";

interface IBatchAction extends Omit<IBatchCollection, "number"> {
  collection: string[] | number[];
  buttonList?: ReactNode;
}

const BatchAction: React.FC<IBatchAction> = (props) => {
  const { total, collection, buttonList, handleCancel, handleSelectAll } =
    props;
  useEffect(() => {
    console.log(collection, 'collection')
  }, [collection]);
  return (
    <div className="batch-action-wrapper">
      <BatchCollection
        handleCancel={handleCancel}
        handleSelectAll={handleSelectAll}
        number={collection.length}
        total={total}
      />
      <div className="btn-group-wrapper">{buttonList}</div>
    </div>
  );
};
export default BatchAction;
